module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_b-670d61f972b6177f85741316c1e644a0.png";